<div class="login-container">
  <div class="login-header">
    <h2><i class="fas fa-lock-open me-2"></i>MV Backoffice</h2>
    <p class="text-muted">Inserisci i dati del tuo account</p>
  </div>

  <form id="loginForm" (submit)="onSubmit()">
    <div class="form-floating">
      <input
        type="email"
        class="form-control"
        id="email"
        placeholder="name@example.com"
        name="username"
        [(ngModel)]="username"
        required
      />
      <label for="email"><i class="fas fa-envelope me-2"></i>Email</label>
    </div>

    <div class="form-floating password-field">
      <input
        type="password"
        class="form-control"
        id="password"
        placeholder="Password"
        name="password"
        [(ngModel)]="password"
        required
      />
      <label for="password"><i class="fas fa-lock me-2"></i>Password</label>
      <span class="password-toggle" onclick="togglePassword()">
        <i class="fas fa-eye" id="toggleIcon"></i>
      </span>
    </div>

    <div class="form-check mb-3">
      <input
        class="form-check-input"
        type="checkbox"
        value=""
        id="rememberMe"
      />
      <label class="form-check-label" for="rememberMe"> Ricordami </label>
    </div>

    <button type="submit" class="btn btn-primary btn-login w-100">
      <i class="fas fa-sign-in-alt me-2"></i>Accedi
    </button>
  </form>

  <!--
  <div class="forgot-password">
    <a href="#" onclick="showForgotPassword()">Forgot your password?</a>
  </div>

  <div class="signup-link">
    <span class="text-muted">Don't have an account? </span>
    <a href="#" onclick="showSignup()">Sign up here</a>
  </div>
  -->
</div>
